import { map as _map } from 'lodash';
import moment from 'moment'; 

export default class UtilsService {
  constructor($http, $q, appConfig, enums) {
    "ngInject";

    this.$http = $http;
    this.$q = $q;
    this.appConfig = appConfig;
    this.enums = enums;
  }

  calculateAmount(calc) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/utils/calculateAmount`, calc);
  }

  calculateMonthly(calc) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/utils/calculateMonthly`, calc);
  }

  calculateTerm(calc) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/utils/calculateTerm`, calc);
  }

  calculateRate(calc) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/utils/calculateRate`, calc);
  }

  getDatePart(dateString) {
    if (dateString) {
      const timeIndex = dateString.search(/T/);

      return new Date(dateString.substring(0, timeIndex));    
    }
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/utilsService.js